module.exports = __webpack_public_path__ + "img/ipad-test-poster.7af519e.jpg";